import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './PrizeDropPage.scss'

const PrizeDropPage = () => {
	return (
		<div className="main-content prize-drop-page">
			<GamificationBlock
				domId={WIDGETS.prizeDrop.domId}
				url={WIDGETS.prizeDrop.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default PrizeDropPage
